import {EntityService} from 'src/service/EntityService';

export class ProductService extends EntityService {

  static entity = 'iam-main/products';

  static getExpireDate(productId: string, effectiveDate: string): Promise<any> {
    return this.axios.get(`${this.entity}/expire-calculate?productId=${productId}&effectiveDate=${effectiveDate}`).then(res => res.data);
  }
  static findBySupplierId(supplierPartyId: string, orderId: string): Promise<any> {
    return this.axios.get(`${this.entity}/find?supplierPartyId=${supplierPartyId}&orderId=${orderId}`).then(res => res.data);
  }

  static uploadExcel(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/import-excel`, data).then(res => res.data);
  }

}